<div class="question" *ngIf="question" [@slide]="animationState">
  <p class="question__title">{{ question.title }}</p>
  <div class="focus" id="focus" tabindex="0"></div>

  <div class="answer-group" *ngIf="question.type === 'dropdown'">
    <ng-select
      placeholder="Select"
      class="select-answer"
      bindLabel="title"
      bindValue="value"
      [clearable]="false"
      [searchable]="false"
      (change)="dropdownChanged($event)"
    >
      <ng-option *ngFor="let answer of question.answers" [value]="answer">{{
        answer.title
      }}</ng-option>
    </ng-select>

    <!--<select (change)="dropdownChanged($event)">
      <option>Select</option>
      <option
        *ngFor="let answer of question.answers"
        [value]="answer.title"
        [selected]="selectedAnswer.title === answer.title">
        {{ answer.title }}
      </option>
    </select>-->
  </div>

  <div class="answer-group" *ngIf="question.type !== 'dropdown'">
    <ng-container *ngFor="let answer of question.answers">
      <button
        class="answer-group__button"
        [class.selected]="selectedAnswer.title === answer.title"
        type="button"
        [id]="answer.title"
        (click)="clickAnswer(answer)"
      >
        {{ answer.title }}
      </button>
    </ng-container>
  </div>
</div>
